import React from 'react'
import style from './review.mod.scss'
import Img from 'gatsby-image'
import { FaStar } from 'react-icons/fa'
import uniqid from 'uniqid'

const Review = ({ image, name, rating, date, text }) => {
  return (
    <div className={style.review}>
      <div className={style.review__image}>
        <Img fluid={image.fluid} />
      </div>
      <div className={style.review__stars}>
        {[...Array(rating)].map(() => (
          <FaStar key={`star-rating-${uniqid()}`} />
        ))}
      </div>
      <div className={style.review__text}>
        <p>{text}</p>
      </div>
      <div className={style.review__info}>
        <p className={style.review__name}>{name}</p>
        <p className={style.review__date}>{date}</p>
      </div>
    </div>
  )
}

export default Review
